import React from "react";

// Function to format date as "DD.MM.YYYY"
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0"); // Ensures two digits for day
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensures two digits for month (months are 0-based)
  const year = date.getFullYear();
  return `${day}.${month}.${year}`; // Returns date in the format: "03.01.2025"
};

const PrepnexaNews = ({ posts }) => {
  return (
    <div className="container mx-auto px-4 py-10">
      <div className="text-2xl font-extrabold text-gray-900 mb-8 mx-0 sm:mx-10">
        <h4>PrepNexis News</h4>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mx-0 sm:mx-10">
        {posts.map((post, index) => (
          <div
            key={index}
            className="bg-white rounded-md border border-slate-200 shadow-sm overflow-hidden transition-all duration-300 transform hover:-translate-y-0.5 hover:border-[rgba(126,34,206,0.28)] hover:shadow-md"
          >
            <a
              href={post.link}
              title={post.title}
              className="block overflow-hidden"
            >
              <img
                className="w-full h-48 object-cover transition duration-500 hover:scale-105"
                src={
                  post.featuredImage
                    ? `${process.env.REACT_APP_DO_SPACES_URL}${post.featuredImage}`
                    : "/placeholder.jpg" // Fallback image
                }
                alt={post.title}
              />
            </a>
            <div className="p-4">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm font-medium text-gray-600">
                <span>{post?.author || "Unknown Author"}</span>{" "}
                {/* Author */}
                <span>-</span>
                <span>
                  {formatDate(post?.date) || "No date available"}
                </span>{" "}
                {/* Formatted date */}
              </div>
              <div className="text-sm text-gray-500 mb-2">
                {post?.readMins || "N/A"} {/* Read time */}mins read
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                <a
                  href={post.link}
                  title={post.title}
                  className="hover:text-[rgb(126,34,206)]"
                >
                  {post.title}
                </a>
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrepnexaNews;
